import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { Dashboard } from "./dashboard/detail/Dashboard";
import { DashboardEdit } from "./dashboard/edit/DashboardEdit";
import ExchangeDetail from "./exchange/detail/ExchangeDetail";
import ExchangeCreate from "./exchange/create/ExchangeCreate";
import OcList from "./overseasCorporation/list/OcList";
import OcColumn from "./overseasCorporation/column/OcColumn";
import SalesList from "./sales/list/SalesList";
import SalesExpected from "./sales/expected/SalesExpected";
import SalesColumn from "./sales/column/SalesColumn";
import SalesCompany from "./sales/company/SalesCompany";

export default function Main() {
    const { key } = useLocation()

    return <Routes>
        <Route key={key} path={"dashboard"} element={<Dashboard />} />
        <Route key={key} path={"dashboard/edit"} element={<DashboardEdit />} />
        <Route key={key} path={"sales/list"} element={<SalesList />} />
        <Route key={key} path={"sales/expected"} element={<SalesExpected />} />
        <Route key={key} path={"sales/column"} element={<SalesColumn />} />
        <Route key={key} path={"sales/company"} element={<SalesCompany />} />
        <Route key={key} path={"overseas/list"} element={<OcList />} />
        <Route key={key} path={"overseas/column"} element={<OcColumn />} />
        <Route key={key} path={"exchange"} element={<ExchangeDetail />} />
        <Route key={key} path={"exchange/create"} element={<ExchangeCreate />} />
        <Route key={key} path={"*"} element={<Navigate to={"/not_found"} />} />
    </Routes>
}